<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6 xl4>
        <v-card light>
          <v-toolbar dark>
            <v-toolbar-title>後台管理系統</v-toolbar-title>
          </v-toolbar>

          <v-form v-model="valid" @submit.prevent="login">
            <v-card-text>
              <v-text-field
                v-model="form.email"
                :rules="[formRules.required, formRules.email]"
                label="帳號信箱"
                outlined
                prepend-inner-icon="mdi-account"
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="form.password"
                :rules="[formRules.required]"
                label="密碼"
                outlined
                prepend-inner-icon="mdi-key"
              ></v-text-field>

              <v-btn type="submit" :disabled="!valid" outlined large block class="mb-3">登入</v-btn>

              <div class="text-right">
                <v-btn
                  to="/password/request"
                  text
                  color="primary"
                  style="text-decoration: underline"
                >忘記密碼</v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { mapState, mapActions } from "vuex";

import adminApi from "@/api/admin";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      valid: false,

      form: {
        email: "",
        password: ""
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),
    ...mapActions("admin", ["set_jwt", "set_info"]),

    login() {
      adminApi
        .login(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: "登入失敗，請重新登入"
            });

            return;
          }

          const { access_token, role_id, expires_in } = res;

          this.set_jwt({ access_token, role_id });

          Cookies.set(
            "cocobar",
            {
              access_token: access_token,
              role_id: role_id
            },
            {
              expires: expires_in / 60 / 60 / 24
            }
          );

          this.$router.push("/");
        })
        .catch(err => {});
    }
  },

  mounted() {
    // init
    this.set_jwt({
      access_token: "",
      expires_in: 0
    });

    this.set_info({
      username: "",
      email: ""
    });
  }
};
</script>

<style lang="scss" scoped>
</style>
